import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { createBrowserHistory, History } from 'history';
import { connectRouter, routerMiddleware } from 'connected-react-router';

import newOffer from './newOffer';
import business from './business';
import login from './login';
import offers from './offers';
import billing from './billing';
import applyOffers from './applyOffers';

const history: History = createBrowserHistory();
const composeEnhancers: Function = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = (history: History) =>
  combineReducers({
    router: connectRouter(history),
    newOffer,
    login,
    business,
    offers,
    billing,
    applyOffers,
  });

export default function configureStore() {
  return createStore(
    rootReducer(history),
    {},
    composeEnhancers(
      applyMiddleware(
        routerMiddleware(history), // for dispatching history actions
        thunk
      )
    )
  );
}

export { history };
